import BasicDetailsContainer from "./BasicDetailsContainer";

export default BasicDetailsContainer;
